var TrackingType;
(function (TrackingType) {
    TrackingType["CUSTOM_CLICK_TRACK"] = "customClickTrack";
})(TrackingType || (TrackingType = {}));
var AreaProduct;
(function (AreaProduct) {
    AreaProduct["CHECKOUT"] = "Checkout";
    AreaProduct["PAYMENT"] = "Payment";
})(AreaProduct || (AreaProduct = {}));
var TrackingIdentifier;
(function (TrackingIdentifier) {
    TrackingIdentifier["APPLE_PAY"] = "ApplePay";
    TrackingIdentifier["ADYEN"] = "Adyen";
    TrackingIdentifier["PAYPAL_PREVIEW_BUTTON"] = "Paypal Preview Button";
})(TrackingIdentifier || (TrackingIdentifier = {}));

export { AreaProduct, TrackingIdentifier, TrackingType };
//# sourceMappingURL=AdobeTracking.js.map
